<div *ngIf="isPopulated">
  <eds-section-header
    [level]="4"
    size="h6"
    edsSpacing="md"
    [title]="'products.portfolio-manager-roster-heading' | translate"
    caveatPlacement="manager-allocation-caveat"
    [asOfLabel]="'products.as-of' | translate"
    [asOfDate]="data.asOfDate"
    [calculationBasis]="'products.invested-capital' | translate"
    [updateFrequency]="data.updateFrequency"
  ></eds-section-header>

  <eds-proximal placement="manager-roster-proximal-top"></eds-proximal>
  <div edsSubGrid="layout-1">
    <div *ngFor="let strategy of data.strategies">
      <table class="table table--secondary">
        <thead class="table__thead">
          <tr class="table__tr">
            <th class="table__th">
              <strong>{{ strategy.strategy }}</strong>
            </th>
            <th class="table__th text-align-right">
              <strong
                >{{ "products.manager-roster-allocation" | translate }}<br />{{
                  strategy.totalAllocation
                }}</strong
              >
            </th>
          </tr>
        </thead>
        <tbody class="table__body">
          <tr class="table__tr" *ngFor="let manager of strategy.allocations">
            <td class="table__td">
              <a
                *ngIf="manager.longDescription"
                href="#"
                (click)="showPopup($event, manager)"
                >{{
                  manager.displayName
                    ? manager.displayName
                    : manager.managerRoster
                }}</a
              >
              <span
                *ngIf="!manager.longDescription"
                [innerHtml]="
                  manager.displayName
                    ? manager.displayName
                    : manager.managerRoster
                "
              ></span>
              <ng-container *ngIf="manager.shortDescription">
                <br />
                {{ manager.shortDescription }}
              </ng-container>
            </td>
            <td class="table__td text-align-right">
              {{ manager.allocation }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <eds-dialog [dialogId]="'managerRosterPopup'"></eds-dialog>
</div>
